import { compose, setDisplayName } from 'recompose';
import { withModal } from 'components/Modal/withModal';
import TutorialModal from './TutorialModal';
import view from './view';

export default compose(
  setDisplayName('Tutorial'),
  withModal('tutorial', TutorialModal)
)(view);
